export default __webpack_public_path__ + "static/media/PuraTernura.5bf18c3a.png";